import type { SearchMode } from './searchMode';
import { SearchModeEnum } from './searchMode';
import type { SearchParameters } from '../searchParameters';
import { isBlankPhrase } from '../searchParameters';

// A curated set or stack with a phrase is a search within it, not a view of it.
export const isRecentlyViewedCuratedSetOrStack = (
  searchMode: SearchMode,
  searchParameters: SearchParameters
): boolean => {
  switch (searchMode.kind) {
    case SearchModeEnum.RECENTLY_VIEWED:
      return true;
    case SearchModeEnum.STACK:
    case SearchModeEnum.CURATED_SET:
      return isBlankPhrase(searchParameters);
    default:
      return false;
  }
};

const startsFromSource = (searchParameters: SearchParameters): boolean =>
  searchParameters.searchByImage ||
  !!(
    searchParameters.artistexact ||
    searchParameters.contributor ||
    searchParameters.morelikethis ||
    searchParameters.recentlyviewed
  );

const isSetViewedWithoutPhrase = (
  searchParameters: SearchParameters
): boolean =>
  !!(searchParameters.stackid || searchParameters.curatedset) &&
  isBlankPhrase(searchParameters);

// A search whose results are anchored to something other than a phrase: an
// artist, a contributor's portfolio, an image, a similar asset, recently
// viewed, or a stack or curated set viewed without a phrase.
//
// Reads the parameters directly rather than the mode: the mode picks one kind
// by precedence, and a search carrying several of these is anchored whichever
// one it picks. A phrase corrected to asset ids is anchored too, but that
// correction comes back with the results, so callers that care check it
// themselves.
export const isAnchoredSearch = (searchParameters: SearchParameters): boolean =>
  startsFromSource(searchParameters) ||
  isSetViewedWithoutPhrase(searchParameters);
